export const itemSelectedEvent = 'item-selected';
export const collapseEvent = 'collapsed';
export const expandEvent = 'expanded';
